export const SET_LANGUAGE = 'SET_LANGUAGE'
export const SET_SPEECH = 'SET_SPEECH'
export const OPEN_CHAT = 'OPEN_CHAT'
export const CLOSE_CHAT = 'CLOSE_CHAT'
export const CLOSE_CHAT_VIA_X = 'CLOSE_CHAT_VIA_X'
export const MAXIMIZE_CHAT = 'MAXIMIZE_CHAT'
export const MINIMIZE_CHAT = 'MINIMIZE_CHAT'
export const ACCEPTED_INVITATION = 'ACCEPTED_INVITATION'
export const DECLINED_INVITATION = 'DECLINED_INVITATION'
export const CLICKED_TRIGGER_BUTTON = 'CLICKED_TRIGGER_BUTTON'
export const SET_DEVICE_INFO = 'SET_DEVICE_INFO'
export const GET_DEVICE_INFO = 'GET_DEVICE_INFO'
export const OPEN_WIDGET = 'OPEN_WIDGET'
export const START_CONVERSATION = 'START_CONVERSATION'
export const CLOSE_CONVERSATION = 'CLOSE_CONVERSATION'
export const STARTED_CONVERSATION = 'STARTED_CONVERSATION'
export const CLOSED_CONVERSATION = 'CLOSED_CONVERSATION'
export const LOG_IN = 'LOG_IN'
export const FAKE_LOG_IN = 'FAKE_LOG_IN'
export const LOG_OUT = 'LOG_OUT'
export const ADD_BOT_MESSAGE = 'ADD_BOT_MESSAGE'
export const ADD_OPERATOR_MESSAGE = 'ADD_OPERATOR_MESSAGE'
export const UPDATE_SUGGESTIONS = 'UPDATE_SUGGESTIONS'
export const UPDATE_SEMANTIC_SUGGESTIONS = 'UPDATE_SEMANTIC_SUGGESTIONS'
export const ADD_NOTIFICATION_MESSAGE = 'ADD_NOTIFICATION_MESSAGE'
export const EMIT_NEW_USER_MESSAGE = 'EMIT_NEW_USER_MESSAGE'
export const ADD_TRANSCRIBED_USER_MESSAGE = 'ADD_TRANSCRIBED_USER_MESSAGE'
export const EMIT_USER_LOGIN_MESSAGE = 'EMIT_USER_LOGIN_MESSAGE'
export const EMIT_FAKE_USER_LOGIN_MESSAGE = 'EMIT_FAKE_USER_LOGIN_MESSAGE'
export const EMIT_USER_RESTART_MESSAGE = 'EMIT_USER_RESTART_MESSAGE'
export const CLEAR_MESSAGES = 'CLEAR_MESSAGES'
export const OPEN_NEW_TICKET = 'OPEN_NEW_TICKET'
export const BOT_CONNECT = 'BOT_CONNECT'
export const BOT_DISCONNECT = 'BOT_DISCONNECT'
export const TOGGLE_TYPING = 'TOGGLE_TYPING'
export const SET_EMOTION = 'SET_EMOTION'
export const SET_INPUT_ENABLED = 'SET_INPUT_ENABLED'
export const SET_BACK_DISABLED = 'SET_BACK_DISABLED'
export const SET_BACK_INPUT_DISABLED = 'SET_BACK_INPUT_DISABLED'
export const SET_OCCUPIED_DATES = 'SET_OCCUPIED_DATES'
export const SET_CONFIG = 'SET_CONFIG'
export const EMIT_USER_MESSAGE_FEEDBACK = 'EMIT_USER_MESSAGE_FEEDBACK'
export const EMIT_SENT_FEEDBACK = 'EMIT_SENT_FEEDBACK'
export const SET_FILE_UPLOAD_ENABLED = 'SET_FILE_UPLOAD_ENABLED'
export const IS_RESTRICTED = 'IS_RESTRICTED'
export const REQUEST_SEMANTIC_SUGGESTIONS = 'REQUEST_SEMANTIC_SUGGESTIONS'
export const ADD_UPLOADED_FILES = 'ADD_UPLOADED_FILES'
export const CLEAR_FILES = 'CLEAR_FILES'
export const SET_POST_MESSAGE_TARGET = 'SET_POST_MESSAGE_TARGET'
export const SHOW_PROACTIVE_MESSAGE = 'SHOW_PROACTIVE_MESSAGE'
export const SET_BACK_BUTTON_ENABLED = 'SET_BACK_BUTTON_ENABLED'
export const SET_ENABLED_LANGUAGES = 'SET_ENABLED_LANGUAGES'
// export const SET_FILE_UPLOAD_ENABLED = 'SET_FILE_UPLOAD_ENABLED'
export const SET_PDF_DOWNLOAD_ENABLED = 'SET_PDF_DOWNLOAD_ENABLED'
export const GET_CONVERSATION_PDF = 'GET_CONVERSATION_PDF'
export const SET_SEMANTIC_SUGGESTIONS_ENABLED =
  'SET_SEMANTIC_SUGGESTIONS_ENABLED'
